// import React, { useEffect, useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import 'dashboard/newDashboard.scss';
// import { getProfileId, getProfileBlueRingPreferences, getHealthScore } from 'app/selectors';
// import { LinkWrapper, Icon, Loading } from 'shared';
// import { buildPath, routePaths } from 'services/routing';
// import RingButton from './RingButton';
// import { defaultDashboardCirclePreferences } from 'app/config';
// import { DashboardCircleIcons, blueCircleClasses } from './DashboardCircleIcons';
// import { loadHealthScore } from '../health/action-creators';
// import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
// import 'react-circular-progressbar/dist/styles.css';
// import AnimatedProgressProvider from './AnimatedProgressProvider';
// import { easeQuadInOut } from 'd3-ease';
// import local from 'services/localization/local';
// import { loadMedications } from 'health/medication/action-creators';
// import { loadConnectedDevices } from 'devices/devices-actions';
// import brain from '../shared/fullColorIcons/svgs/ai-summary.png';
// import spark from '../shared/fullColorIcons/svgs/spark.png';
// import red from '../shared/fullColorIcons/svgs/red-icon.png';
// import green from '../shared/fullColorIcons/svgs/green-icon.png';
// import yellow from '../shared/fullColorIcons/svgs/yellow-icon.png';
// import MedicationIcon from 'shared/fullColorIcons/svgs/medication.svg';
// import { fetchAIHealthSummary } from './v1/aiHealthSummary.slice';
// import { Steps, BloodOxygen, Nutrition, Weight, HeartRate, Temperature, BodyFat, BloodGlucose, Sleep, BloodPressure, Height } from 'shared/fullColorIcons';
// import { NavIcon } from 'shared';
// import { Link } from 'react-router-dom/cjs/react-router-dom.min';

// export default function NewDashboardCircle() {
//   const dispatch = useDispatch();
//   const profileId = useSelector(getProfileId);
//   const blueRingPreference = useSelector(getProfileBlueRingPreferences);
//   const circlePrefences = blueRingPreference == '' ? defaultDashboardCirclePreferences : blueRingPreference;
//   let healthScore = useSelector(getHealthScore);

//   const [showAllVitals, setShowAllVitals] = useState(false);
//   const [showAllMonitoring, setShowAllMonitoring] = useState(false);
//   const [expanded, setExpanded] = useState(false);


//   const { data, loading, error } = useSelector(
//     (state) => state.aiHealthSummary
//   );

//   console.log(data);


//   useEffect(() => {
//     if (!profileId) return;
//     dispatch(loadHealthScore(profileId));
//     dispatch(loadMedications(profileId));
//     dispatch(loadConnectedDevices(profileId));
//     if (!data && !loading) {
//       dispatch(fetchAIHealthSummary(profileId));
//     }
//   }, [profileId, data, loading, dispatch]);



//   const aiSummary = React.useMemo(() => {
//     if (!data) return null;

//     try {
//       if (typeof data === 'string') {
//         return JSON.parse(data);
//       }

//       if (typeof data === 'object') {
//         return data;
//       }

//       return null;
//     } catch (err) {
//       console.error('AI Summary parse failed', err, data);
//       return null;
//     }
//   }, [data]);

//   console.log(aiSummary);

//   const summaryText = aiSummary?.summary;
//   const keyVitals = aiSummary?.keyVitalsCards;
//   const monitoring = aiSummary?.monitoring;
//   const ehrSummary = aiSummary?.ehrSummary?.[0];

//   const overallSummary = ehrSummary?.overallSummary;

//   let sectionWiseData = null;

//   try {
//     sectionWiseData = ehrSummary?.sectionWiseSummary
//       ? JSON.parse(ehrSummary.sectionWiseSummary)
//       : null;
//   } catch (err) {
//     console.error("Error parsing sectionWiseSummary", err);
//   }

//   const medications = sectionWiseData?.medications || [];
//   console.log(medications);

//   const visibleVitals = showAllVitals
//     ? keyVitals
//     : keyVitals?.slice(0, 2);

//   const visibleMonitoring = showAllMonitoring
//     ? monitoring
//     : monitoring?.slice(0, 2);

//   const vitalIconMap = {
//     'Heart Rate': HeartRate,
//     'Body Fat Percentage': BodyFat,
//     'Daily Steps': Steps,
//     'Blood Glucose': BloodGlucose,
//     'Sleep Duration': Sleep,
//     'Blood Pressure': BloodPressure,
//     'Weight': Weight,
//     'Height': Height,
//     'Blood Oxygen': BloodOxygen,
//     'Temperature': Temperature,
//     'Nutrition': Nutrition
//   };



//   return (
//     <div>
//       {loading &&
//         <section id="program-section">
//           <div className='program-dashboard-tile'>
//             <Loading></Loading>
//           </div>
//         </section>
//       }

//       {
//         !loading && (
//           <div>
//             {summaryText && summaryText.trim() !== "" && (
//               <div className="aisummary-container">

//                 {/* Header */}
//                 <div
//                   style={{
//                     background: "#F5F6F8",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "8px 10px"
//                   }}
//                 >
//                   <img
//                     src={brain}
//                     alt="AI Summary"
//                     style={{ height: "60px", width: "70px", flexShrink: 0 }}
//                   />

//                   <div style={{ display: "flex", flexDirection: "column" }}>
//                     <h3
//                       style={{
//                         margin: 0,
//                         fontSize: "16px",
//                         fontWeight: 600,
//                         color: "#111827"
//                       }}
//                     >
//                       {local.aiSummary}
//                     </h3>

//                     <p
//                       style={{
//                         margin: "4px 0 0",
//                         fontSize: "13px",
//                         color: "#6B7280",
//                         lineHeight: "1.4"
//                       }}
//                     >
//                       {local.aiSummarySubNotes}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Summary Content */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "flex-start",
//                     gap: "10px",
//                     marginTop: "10px",
//                     padding: "0 12px"
//                   }}
//                 >
//                   <img
//                     src={spark}
//                     alt="AI Spark"
//                     style={{ height: "30px", width: "30px", marginTop: "3px" }}
//                   />

//                   <div style={{ flex: 1 }}>

//                     <p
//                       style={{
//                         margin: 0,
//                         fontSize: "14px",
//                         lineHeight: "1.6",
//                         color: "#111827",
//                         display: "-webkit-box",
//                         WebkitLineClamp: expanded ? "unset" : 3,
//                         WebkitBoxOrient: "vertical",
//                         overflow: "hidden"
//                       }}
//                     >
//                       {summaryText}
//                     </p>

//                     <button
//                       type="button"
//                       onClick={() => setExpanded(!expanded)}
//                       style={{
//                         border: "none",
//                         background: "none",
//                         color: "#049fda",
//                         fontSize: "13px",
//                         marginTop: "6px",
//                         padding: 0,
//                         cursor: "pointer",
//                         fontWeight: 500
//                       }}
//                     >
//                       {expanded ? "Show less" : "View full AI summary →"}
//                     </button>

//                   </div>
//                 </div>
//               </div>
//             )}

//             {(keyVitals?.length > 0 || monitoring?.length > 0) && (
//               <div
//                 className="ring-wrapper key-vitals dashboard-card"
//                 style={{
//                   marginTop: "12px",
//                   background: "#F5F6F8",
//                   borderRadius: "14px",
//                   padding: "12px",
//                   margin: "15px 20px"
//                 }}
//               >

//                 {keyVitals?.length > 0 && (
//                   <div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         marginBottom: "5px",
//                         padding: "0px 10px"
//                       }}
//                     >
//                       <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>
//                         Key Vitals
//                       </h4>

//                       {keyVitals?.length > 2 && (
//                         <button
//                           type="button"
//                           onClick={() => setShowAllVitals(prev => !prev)}
//                           style={{
//                             background: "transparent",
//                             border: "none",
//                             color: "#049fda",
//                             fontSize: "13px",
//                             cursor: "pointer",
//                             fontWeight: 500
//                           }}
//                         >
//                           {showAllVitals ? "View Less" : "View More"}
//                         </button>
//                       )}
//                     </div>

//                     <div className="key-vitals-grid">
//                       {visibleVitals.map((vital, index) => {
//                         const IconComponent = vitalIconMap[vital.vitalName];

//                         return (
//                           <div
//                             key={index}
//                             style={{
//                               background: "#FFFFFF",
//                               borderRadius: "12px",
//                               padding: "10px 12px",
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
//                             }}
//                           >
//                             <div>
//                               <div
//                                 style={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '5px',
//                                   fontSize: '14px',
//                                   fontWeight: 500
//                                 }}
//                               >
//                                 {IconComponent && <NavIcon Icon={IconComponent} />}
//                                 <span>{vital.vitalName}</span>
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: "12px",
//                                   color: "#6B7280",
//                                   marginTop: "2px"
//                                 }}
//                               >
//                                 {vital.trend}
//                               </div>
//                             </div>
//                             <div style={{ textAlign: "right" }}>
//                               <div style={{ fontSize: "14px", fontWeight: 600 }}>
//                                 {vital.value}
//                               </div>
//                               <div
//                                 style={{
//                                   display: "inline-block",
//                                   width: "fit-content",
//                                   whiteSpace: "nowrap",
//                                   fontSize: "12px",
//                                   padding: "2px 5px",
//                                   borderRadius: "10px",
//                                   color: "#fff",
//                                   background:
//                                     vital.status === "In range"
//                                       ? "#26c995"
//                                       : vital.status === "Elevated"
//                                         ? "#efa249"
//                                         : "#e25f5f"
//                                 }}
//                               >
//                                 {vital.status}
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 )}

//                 {monitoring?.length > 0 && (
//                   <div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         marginTop: "16px",
//                         marginBottom: "5px",
//                         padding: "0px 10px"
//                       }}
//                     >
//                       <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>
//                         What We're Monitoring
//                       </h4>

//                       {monitoring?.length > 2 && (
//                         <button
//                           type="button"
//                           onClick={() => setShowAllMonitoring(prev => !prev)}
//                           style={{
//                             background: "transparent",
//                             border: "none",
//                             color: "#049fda",
//                             fontSize: "13px",
//                             cursor: "pointer",
//                             fontWeight: 500
//                           }}
//                         >
//                           {showAllMonitoring ? "View Less" : "View full health history"}
//                         </button>
//                       )}
//                     </div>

//                     <div className="monitoring-grid">
//                       {visibleMonitoring.map((monitor, index) => {
//                         const status = monitor.status?.trim().toLowerCase();

//                         const statusIcon =
//                           status === "monitoring"
//                             ? yellow
//                             : status === "active condition"
//                               ? red
//                               : green;

//                         return (
//                           <div
//                             key={index}
//                             style={{
//                               background: "#FFFFFF",
//                               borderRadius: "12px",
//                               padding: "12px 14px",
//                               display: "flex",
//                               gap: "5px",
//                               boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//                               width: "100%"
//                             }}
//                           >
//                             <div
//                               style={{
//                                 width: "25px",
//                                 height: "25px",
//                                 flexShrink: 0,
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center"

//                               }}
//                             >
//                               <img
//                                 src={statusIcon}
//                                 alt=""
//                                 style={{
//                                   width: "100%",
//                                   height: "100%",
//                                   objectFit: "cover",
//                                   transform: "scale(2.0)",
//                                   marginLeft: "-15px"
//                                 }}
//                               />
//                             </div>

//                             <div style={{ display: "flex", flexDirection: "column" }}>
//                               <span className='monitoring-name' title={monitor.name}>
//                                 {monitor.name}
//                               </span>

//                               <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                                 <span
//                                   className='monitor-status'
//                                   style={{
//                                     width: "8px",
//                                     height: "8px",
//                                     borderRadius: "50%",
//                                     marginLeft: "-5px",
//                                     background:
//                                       monitor.status === "Monitoring"
//                                         ? "#F5B400"
//                                         : monitor.status === "Active condition"
//                                           ? "#E53935"
//                                           : "#2E7D32"
//                                   }}
//                                 >
//                                 </span>

//                                 <span style={{ fontSize: "12px", color: "#777", fontWeight: 500 }}>
//                                   {monitor.status}
//                                 </span>
//                               </div>
//                             </div>
//                           </div>
//                         );

//                       })}
//                     </div>
//                   </div>
//                 )}
//                 <LinkWrapper to={routePaths.medicationSummary}>
//                   <div style={{ marginTop: "16px" }}>
//                     <h4
//                       style={{
//                         margin: "0 0 8px 10px",
//                         fontSize: "14px",
//                         fontWeight: 600
//                       }}
//                     >
//                       Medications
//                     </h4>

//                     <div
//                       style={{
//                         width: "100%",
//                         background: "#FFFFFF",
//                         borderRadius: "12px",
//                         padding: "12px 14px",
//                         display: "flex",
//                         alignItems: "center",
//                         boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
//                       }}
//                     >

//                       {/* LEFT CONTENT */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "10px",
//                           flex: 1   // important
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: "32px",
//                             height: "32px",
//                             borderRadius: "50%",
//                             background: "#E6F4EA",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center"
//                           }}
//                         >
//                           <NavIcon Icon={MedicationIcon} />
//                         </div>

//                         <span
//                           style={{
//                             fontSize: "14px",
//                             color: "#555",
//                             flex: 1
//                           }}
//                         >
//                           Review your medications and ensure you’re following your treatment plan.
//                         </span>
//                       </div>

//                       <span
//                         style={{
//                           fontSize: "18px",
//                           color: "#9CA3AF",
//                           marginLeft: "10px"
//                         }}
//                       >
//                         ›
//                       </span>

//                     </div>
//                   </div>
//                 </LinkWrapper>
//                 <LinkWrapper to={routePaths.nextSteps}>
//                   <div className='next-steps'>
//                     <span>Recommended</span> <span>Next Steps</span>
//                   </div>
//                 </LinkWrapper>
//               </div>
//             )}
//           </div>
//         )
//       }


//       <div className="ring-wrapper">
//         <div className="inner-ring-wrapper">
//           <div className="inner-blue-ring">
//             <div className="small-blue-circle"></div>
//             <LinkWrapper data-testid='health-index-ring' id="new-dashboard-circle" to={routePaths.healthIndex}>
//               <div id="healthScore">
//                 <AnimatedProgressProvider
//                   valueStart={0}
//                   valueEnd={healthScore !== null ? healthScore : 0}
//                   duration={1}
//                   easingFunction={easeQuadInOut}
//                   repeat={false}>
//                   {(value) => {
//                     const roundedValue = Math.round(value);
//                     return (
//                       <CircularProgressbarWithChildren
//                         className="healthScore-progressSvg"
//                         value={value}
//                         // text={`Your HealthScore ${roundedValue}`}
//                         maxValue={1000}
//                         /* This is important to include, because if you're fully managing the
//                     animation yourself, you'll want to disable the CSS animation. */
//                         styles={buildStyles({
//                           pathTransition: 'none',
//                           pathColor: '#959494',
//                           trailColor: '#e8ecee'
//                         })}>
//                         <div className="healthScore-title">{local.healthScoreLabel}</div>
//                         <div className="healthScore-wrapper">
//                           <div className="healthScore-count">{roundedValue === 0 ? <Icon className="magnifying-glass" symbol="infoHealthIndexIcon" /> : roundedValue}</div>
//                         </div>
//                       </CircularProgressbarWithChildren>
//                     );
//                   }}
//                 </AnimatedProgressProvider>
//               </div>
//             </LinkWrapper>
//             {circlePrefences?.split(',').map((b, index) =>
//               <RingButton key={`icon_${DashboardCircleIcons[b].name}`} url={DashboardCircleIcons[b].configId ? buildPath(DashboardCircleIcons[b].url, { profileId, configId: DashboardCircleIcons[b].configId }) : buildPath(DashboardCircleIcons[b].url, { profileId })} class={blueCircleClasses[index]} icon={DashboardCircleIcons[b].icon} />
//             )}
//           </div>
//           <div className="teal-line">
//             <RingButton url={buildPath(routePaths.healthSummary, { profileId })} class="teal-ring" icon="timeline" />

//           </div>
//           <div className="magenta-line">
//             <RingButton url={buildPath(routePaths.myGoal, { profileId })} class="magenta-ring" icon="Goal" />
//           </div>
//           <div className="magenta-line"><div className="small-magenta-circle"></div></div>

//           <div className="yellow-line"><div className="small-yellow-circle"></div></div>
//         </div>

//       </div>

//     </div>
//   );
// }


import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'dashboard/newDashboard.scss';
import { getProfileId, getProfileBlueRingPreferences, getHealthScore } from 'app/selectors';
import { LinkWrapper, Icon, Loading } from 'shared';
import { buildPath, routePaths } from 'services/routing';
import RingButton from './RingButton';
import { defaultDashboardCirclePreferences } from 'app/config';
import { DashboardCircleIcons, blueCircleClasses } from './DashboardCircleIcons';
import { loadHealthScore } from '../health/action-creators';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import AnimatedProgressProvider from './AnimatedProgressProvider';
import { easeQuadInOut } from 'd3-ease';
import local from 'services/localization/local';
import { loadMedications } from 'health/medication/action-creators';
import { loadConnectedDevices } from 'devices/devices-actions';
import brain from '../shared/fullColorIcons/svgs/ai-summary.png';
import spark from '../shared/fullColorIcons/svgs/spark.png';
import red from '../shared/fullColorIcons/svgs/red-icon.png';
import green from '../shared/fullColorIcons/svgs/green-icon.png';
import yellow from '../shared/fullColorIcons/svgs/yellow-icon.png';
import MedicationIcon from 'shared/fullColorIcons/svgs/medication.svg';
import { fetchAIHealthSummary } from './v1/aiHealthSummary.slice';
import { Steps, BloodOxygen, Nutrition, Weight, HeartRate, Temperature, BodyFat, BloodGlucose, Sleep, BloodPressure, Height } from 'shared/fullColorIcons';
import { NavIcon } from 'shared';


export default function NewDashboardCircle() {
  const dispatch = useDispatch();
  const profileId = useSelector(getProfileId);
  const blueRingPreference = useSelector(getProfileBlueRingPreferences);
  const circlePrefences = blueRingPreference == '' ? defaultDashboardCirclePreferences : blueRingPreference;
  let healthScore = useSelector(getHealthScore);

  const [showAllVitals, setShowAllVitals] = useState(false);
  const [showAllMonitoring, setShowAllMonitoring] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const summaryRef = useRef(null);

  const { data, loading, error } = useSelector(
    (state) => state.aiHealthSummary
  );

  console.log(data);


  useEffect(() => {
    if (!profileId) return;
    dispatch(loadHealthScore(profileId));
    dispatch(loadMedications(profileId));
    dispatch(loadConnectedDevices(profileId));
    if (!data && !loading) {
      dispatch(fetchAIHealthSummary(profileId));
    }
  }, [profileId, data, loading, dispatch]);



  const aiSummary = React.useMemo(() => {
    if (!data) return null;

    try {
      if (typeof data === 'string') {
        return JSON.parse(data);
      }

      if (typeof data === 'object') {
        return data;
      }

      return null;
    } catch (err) {
      console.error('AI Summary parse failed', err, data);
      return null;
    }
  }, [data]);

  console.log(aiSummary);

  const summaryText = aiSummary?.summary;
  const keyVitals = aiSummary?.keyVitalsCards;
  const monitoring = aiSummary?.monitoring;
  const nextSteps = aiSummary?.nextSteps;
  const ehrSummary = aiSummary?.ehrSummary?.[0];


  let sectionWiseData = null;

  try {
    sectionWiseData = ehrSummary?.sectionWiseSummary
      ? JSON.parse(ehrSummary.sectionWiseSummary)
      : null;
  } catch (err) {
    console.error("Error parsing sectionWiseSummary", err);
  }

  const medications = sectionWiseData?.medications || [];
  console.log(medications);

  const visibleVitals = showAllVitals
    ? keyVitals
    : keyVitals?.slice(0, 2);

  const visibleMonitoring = showAllMonitoring
    ? monitoring
    : monitoring?.slice(0, 2);

  const vitalIconMap = {
    'Heart Rate': HeartRate,
    'Body Fat Percentage': BodyFat,
    'Daily Steps': Steps,
    'Blood Glucose': BloodGlucose,
    'Sleep Duration': Sleep,
    'Blood Pressure': BloodPressure,
    'Weight': Weight,
    'Height': Height,
    'Blood Oxygen': BloodOxygen,
    'Temperature': Temperature,
    'Nutrition': Nutrition
  };
  useEffect(() => {
    if (!summaryRef.current) return;

    const element = summaryRef.current;

    const checkOverflow = () => {
      const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * 3;

      if (element.scrollHeight > maxHeight) {
        setShowToggle(true);
      } else {
        setShowToggle(false);
      }
    };

    setTimeout(checkOverflow, 50);

  }, [summaryText]);

  const hasKeyVitals = keyVitals?.length > 0;
  const hasMonitoring = monitoring?.length > 0;
  const hasMedications = medications?.length > 0;

  const hasNextSteps = nextSteps?.length > 0;

  const hasAnySection =
    hasKeyVitals || hasMonitoring || hasMedications || hasNextSteps;

  return (
    <div>
      {loading &&
        <section id="program-section">
          <div className='program-dashboard-tile'>
            <Loading></Loading>
          </div>
        </section>
      }

      {
        !loading && (
          <div>
            {summaryText && summaryText.trim() !== "" && (
              <div className="aisummary-container">

                {/* Header */}
                <div
                className='summary-head'
                  style={{
                    background: "#F5F6F8",
                    display: "flex",
                    alignItems: "center",
                    padding: "5px 0"
                  }}
                >
                  <img
                    src={brain}
                    alt="AI Summary"
                    style={{ height: "60px", width: "70px", flexShrink: 0 }}
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#111827"
                      }}
                    >
                      {local.aiSummary}
                    </h3>

                    {/* <p
                      style={{
                        margin: "4px 0 0",
                        fontSize: "12px",
                        color: "#6B7280",
                        lineHeight: "1.4"
                      }}
                    >
                      {local.aiSummarySubNotes}
                    </p> */}
                  </div>
                </div>

                {/* Summary Content */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "3px",
                    marginTop: "5px",
                    padding: "0 8px"
                  }}
                >
                  <img
                    src={spark}
                    alt="AI Spark"
                    style={{ height: "25px", width: "25px", marginTop: "3px" }}
                  />

                  <div style={{ flex: 1 }}>

                    <p
                      style={{
                        margin: 0,
                        fontSize: "13px",
                        lineHeight: "1.6",
                        color: "#111827",
                        display: "-webkit-box",
                        WebkitLineClamp: expanded ? "unset" : 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden"
                      }}
                      ref={summaryRef}
                    >
                      {summaryText}
                    </p>
                    {showToggle && (
                      <button
                        type="button"
                        onClick={() => setExpanded(!expanded)}
                        style={{
                          border: "none",
                          background: "none",
                          color: "#049fda",
                          fontSize: "13px",
                          marginTop: "6px",
                          padding: 0,
                          cursor: "pointer",
                          fontWeight: 500
                        }}
                      >
                        {expanded ? "Show less" : "View full AI summary →"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {hasAnySection && (
              <div
                className="key-vitals dashboard-card"
                style={{
                  marginTop: "12px",
                  background: "#F5F6F8",
                  borderRadius: "14px",
                  padding: "12px",
                  margin: "15px 20px"
                }}
              >

                {hasKeyVitals && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "5px",
                        padding: "0px 10px"
                      }}
                    >
                      <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>
                        Key Vitals
                      </h4>

                      {keyVitals?.length > 2 && (
                        <button
                          type="button"
                          onClick={() => setShowAllVitals(prev => !prev)}
                          style={{
                            background: "transparent",
                            border: "none",
                            color: "#049fda",
                            fontSize: "13px",
                            cursor: "pointer",
                            fontWeight: 500
                          }}
                        >
                          {showAllVitals ? "View Less" : "View More"}
                        </button>
                      )}
                    </div>

                    <div className="key-vitals-grid">
                      {visibleVitals.map((vital, index) => {
                        const IconComponent = vitalIconMap[vital.vitalName];

                        return (
                          <div
                            key={index}
                            style={{
                              background: "#FFFFFF",
                              borderRadius: "12px",
                              padding: "10px 12px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '5px',
                                  fontSize: '14px',
                                  fontWeight: 500
                                }}
                              >
                                {IconComponent && <NavIcon Icon={IconComponent} />}
                                <span>{vital.vitalName}</span>
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280",
                                  marginTop: "2px"
                                }}
                              >
                                {vital.trend}
                              </div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                {vital.value}
                              </div>
                              <div
                                style={{
                                  display: "inline-block",
                                  width: "fit-content",
                                  whiteSpace: "nowrap",
                                  fontSize: "12px",
                                  padding: "2px 5px",
                                  borderRadius: "10px",
                                  color: "#fff",
                                  background:
                                    vital.status === "In range"
                                      ? "#26c995"
                                      : vital.status === "Elevated"
                                        ? "#efa249"
                                        : "#e25f5f"
                                }}
                              >
                                {vital.status}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {hasMonitoring && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "16px",
                        marginBottom: "5px",
                        padding: "0px 10px"
                      }}
                    >
                      <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>
                        Monitoring
                      </h4>

                      {monitoring?.length > 2 && (
                        <button
                          type="button"
                          onClick={() => setShowAllMonitoring(prev => !prev)}
                          style={{
                            background: "transparent",
                            border: "none",
                            color: "#049fda",
                            fontSize: "13px",
                            cursor: "pointer",
                            fontWeight: 500
                          }}
                        >
                          {showAllMonitoring ? "View Less" : "View full health history"}
                        </button>
                      )}
                    </div>

                    <div className="monitoring-grid">
                      {visibleMonitoring.map((monitor, index) => {
                        const status = monitor.status?.trim().toLowerCase();

                        const statusIcon =
                          status === "monitoring"
                            ? yellow
                            : status === "active condition"
                              ? red
                              : green;

                        return (
                          <div
                            key={index}
                            style={{
                              background: "#FFFFFF",
                              borderRadius: "12px",
                              padding: "12px 14px",
                              display: "flex",
                              gap: "5px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                              width: "100%"
                            }}
                          >
                            <div
                              style={{
                                width: "25px",
                                height: "25px",
                                flexShrink: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"

                              }}
                            >
                              <img
                                src={statusIcon}
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  transform: "scale(2.0)",
                                  marginLeft: "-15px"
                                }}
                              />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span className='monitoring-name' title={monitor.name}>
                                {monitor.name}
                              </span>

                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <span
                                  className='monitor-status'
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    borderRadius: "50%",
                                    marginLeft: "-5px",
                                    background:
                                      monitor.status === "Monitoring"
                                        ? "#F5B400"
                                        : monitor.status === "Active condition"
                                          ? "#E53935"
                                          : "#2E7D32"
                                  }}
                                >
                                </span>

                                <span style={{ fontSize: "12px", color: "#777", fontWeight: 500 }}>
                                  {monitor.status}
                                </span>
                              </div>
                            </div>
                          </div>
                        );

                      })}
                    </div>
                  </div>
                )}

                {hasMedications && (
                  <LinkWrapper to={routePaths.medicationSummary}>
                    <div style={{ marginTop: "16px" }}>
                      <h4
                        style={{
                          margin: "0 0 8px 10px",
                          fontSize: "14px",
                          fontWeight: 600
                        }}
                      >
                        Medications
                      </h4>

                      <div
                        style={{
                          width: "100%",
                          background: "#FFFFFF",
                          borderRadius: "12px",
                          padding: "12px 14px",
                          display: "flex",
                          alignItems: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: 1
                          }}
                        >
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: "#E6F4EA",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <NavIcon Icon={MedicationIcon} />
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              flex: 1
                            }}
                          >
                            Review your medications and ensure you’re following your treatment plan.
                          </span>
                        </div>

                        <span
                          style={{
                            fontSize: "18px",
                            color: "#9CA3AF",
                            marginLeft: "10px"
                          }}
                        >
                          ›
                        </span>

                      </div>
                    </div>
                  </LinkWrapper>
                )}

                {hasNextSteps && (
                  <LinkWrapper to={routePaths.nextSteps}>
                    <div className='next-steps'>
                      <span>Recommended</span> <span>Next Steps</span>
                    </div>
                  </LinkWrapper>
                )}
              </div>
            )}
          </div>
        )
      }


      <div className="ring-wrapper">
        <div className="inner-ring-wrapper">
          <div className="inner-blue-ring">
            <div className="small-blue-circle"></div>
            <LinkWrapper data-testid='health-index-ring' id="new-dashboard-circle" to={routePaths.healthIndex}>
              <div id="healthScore">
                <AnimatedProgressProvider
                  valueStart={0}
                  valueEnd={healthScore !== null ? healthScore : 0}
                  duration={1}
                  easingFunction={easeQuadInOut}
                  repeat={false}>
                  {(value) => {
                    const roundedValue = Math.round(value);
                    return (
                      <CircularProgressbarWithChildren
                        className="healthScore-progressSvg"
                        value={value}
                        // text={`Your HealthScore ${roundedValue}`}
                        maxValue={1000}
                        /* This is important to include, because if you're fully managing the
                    animation yourself, you'll want to disable the CSS animation. */
                        styles={buildStyles({
                          pathTransition: 'none',
                          pathColor: '#959494',
                          trailColor: '#e8ecee'
                        })}>
                        <div className="healthScore-title">{local.healthScoreLabel}</div>
                        <div className="healthScore-wrapper">
                          <div className="healthScore-count">{roundedValue === 0 ? <Icon className="magnifying-glass" symbol="infoHealthIndexIcon" /> : roundedValue}</div>
                        </div>
                      </CircularProgressbarWithChildren>
                    );
                  }}
                </AnimatedProgressProvider>
              </div>
            </LinkWrapper>
            {circlePrefences?.split(',').map((b, index) =>
              <RingButton key={`icon_${DashboardCircleIcons[b].name}`} url={DashboardCircleIcons[b].configId ? buildPath(DashboardCircleIcons[b].url, { profileId, configId: DashboardCircleIcons[b].configId }) : buildPath(DashboardCircleIcons[b].url, { profileId })} class={blueCircleClasses[index]} icon={DashboardCircleIcons[b].icon} />
            )}
          </div>
          <div className="teal-line">
            <RingButton url={buildPath(routePaths.healthSummary, { profileId })} class="teal-ring" icon="timeline" />

          </div>
          <div className="magenta-line">
            <RingButton url={buildPath(routePaths.myGoal, { profileId })} class="magenta-ring" icon="Goal" />
          </div>
          <div className="magenta-line"><div className="small-magenta-circle"></div></div>

          <div className="yellow-line"><div className="small-yellow-circle"></div></div>
        </div>

      </div>

    </div>
  );
}
